import { SectionType } from "@/api/interfaces/pageLayout";
import { renderCmsBlocks } from "@/base/blocks/blockRegistry";
import MyNextGiftCardBlock from "@/base/blocks/MyNextGiftCardBlock/MyNextGiftCardBlock";
import PerkBlock from "@/base/blocks/PerkBlock/PerkBlock";
import { CmsBlocks } from "@/base/components/Global";
import { CmsPage } from "@/base/components/Global/cmsPage";
import { fetchMyGiftCardPage } from "@/store/cms";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

const giftCardRegistry = {
  [SectionType.GIFT_CARDS]: PerkBlock,
  [SectionType.BKK5]: MyNextGiftCardBlock,
};

const GiftCardPage = () => {
  const myGiftCardPage = useAppSelector((state) => state.cms.myGiftCardPage);
  const dispatch = useAppDispatch();

  return (
    <CmsPage
      name="GiftCardPage"
      pageStateMachine={myGiftCardPage}
      fetchPage={() => dispatch(fetchMyGiftCardPage())}
    >
      {({ page }) => (
        <CmsBlocks>
          {renderCmsBlocks(page.components, giftCardRegistry)}
        </CmsBlocks>
      )}
    </CmsPage>
  );
};

export default GiftCardPage;
